import React from "react";

function Footer() {
  return (
    <div
      style={{
        color: "white",
        background: "#7f1b47",
        textAlign: "center",
        padding: "1rem",
        fontWeight: "bold",
      }}
    >
      {" "}
      Developed with React JS By Sherefat Onibile{" "}
    </div>
  );
}

export default Footer;
